// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardWrapper_wrapper__QiCVf","settings":"DashboardWrapper_settings__SL2hT"};